import Col from "@visa/vds/col";
import Icon from "@visa/vds/icon";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import React from "react";
const ReorderNote = () => {
  return (
    <>
      <Row>
        <Col>
          <Typography tag="h4" variant="subtitle">
            <Icon name="info" resolution="tiny" />
            &nbsp; Drag and drop to re-order the data. Click <b>
              SAVE REORDER
            </b>{" "}
            to save the current ordering, or <b>CANCEL REORDER</b> to exit the
            re-ordering.
          </Typography>
        </Col>
      </Row>
    </>
  );
};
export default ReorderNote;
